(function(){
    window.share = {}

    const channels = {
        facebook: {
            url: 'https://www.facebook.com/sharer/sharer.php',
            data: value => ({ u: value('url') })
        },
        twitter: {
            url: 'https://twitter.com/intent/tweet/',
            data: value => ({
                text: value('title'),
                url: value('url'),
                hashtags: value('hashtags'),
                via: value('via')
            })
        },
        linkedin: {
            url: 'https://www.linkedin.com/shareArticle',
            data: value => ({
                url: value('url'),
                mini: true
            })
        },
        email: {
            url: 'mailto:',
            data: value => ({
                subject: value('subject'),
                body: value('title') + '\n' + value('url')
            })
        },
        whatsapp: {
            url: 'whatsapp://send',
            data: value => ({
                text: value('title') + ' ' + value('url')
            })
        },
        pinterest: {
            url: 'https://www.pinterest.com/pin/create/button/',
            data: value => ({
                url: value('url'),
                media: value('image'),
                description: value('description')
            })
        },
    };

    for (let channel in channels) {
        const channelOptions = channels[channel];

        window.share[channel] = function (values) {
            const elem = (this instanceof Element || this instanceof HTMLDocument) ? this : undefined;

            const defaults = {
                url: window.location.href,
                title: document.title,
                width: 600,
                height: 480
            };

            function getValue(param) {
                if (values instanceof Object && values !== null) {
                    if (values[param]) return values[param];
                }
                if (elem) {
                    const val = elem.getAttribute('data-' + param);
                    if (val) return val;
                }
                if (defaults[param]) return defaults[param];
            }

            const data = channelOptions.data(getValue);
            const url = channelOptions.url + '?' + Object.keys(data).filter(param => !!data[param]).map(function (param) {
                return encodeURIComponent(param) + '=' + encodeURIComponent(data[param]);
            }).join('&');

            if (url.indexOf('http') === 0) {
                const width = getValue('width'), height = getValue('height'),
                      left = window.innerWidth / 2 - width / 2 + window.screenX,
                      top = window.innerHeight / 2 - height / 2 + window.screenY,
                      params = 'scrollbars=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left,
                      newWindow = window.open(url, '', params);

                if (!newWindow) window.location.href = url;
                else if (newWindow.focus) newWindow.focus();
            } else {
                window.location.href = url;
            }
        }
    }
})()
